import { takeLatest, call, put, select } from 'redux-saga/effects';
import * as C from './constants';
import PlayerService from './service';
import * as A from './actions';
import { IS_TEST_ENVIRONMENT } from '../../constants';
import * as SL from './selectors';

/** *************************************************************
 *                   Shows API requests
 ************************************************************* */
export const watchShowApiRequest = function* () {
  yield takeLatest(C.SHOW_API_REQUEST_INIT, handleShowApiRequest);
};

export const handleShowApiRequest = function* (action: ReturnType<typeof A.showApiRequestInit>) {
  try {
    const { id, limit, trackId } = action.payload;
    const data: Awaited<ReturnType<typeof PlayerService.getShowDetail>> = yield call(
      PlayerService.getShowDetail,
      { showId: id, limit },
    );
    yield put(A.showApiRequestSuccess({ data, trackId }));
  } catch (error) {
    if (!IS_TEST_ENVIRONMENT) {
      console.error('Player.sagas.handleShowApiRequest()', error);
    }
    if (error instanceof Error) {
      yield put(A.showApiRequestFailure({ errorMessage: error.message }));
    }
  }
};

/** *************************************************************
 *                   Track API requests
 ************************************************************* */
export const watchTrackApiRequest = function* () {
  yield takeLatest(C.TRACK_API_REQUEST_INIT, handleTrackApiRequest);
};

export const handleTrackApiRequest = function* (action: ReturnType<typeof A.trackApiRequestInit>) {
  const { id, setShowIdFromResult } = action.payload;

  try {
    const track: Awaited<ReturnType<typeof PlayerService.getTrackInfo>> = yield call(
      PlayerService.getTrackInfo,
      id,
    );

    yield put(A.trackApiRequestSuccess({ track }));

    if (setShowIdFromResult) {
      const showId = track?.show?.id;
      if (showId) {
        yield put(A.showId({ showId }));
        yield put(A.showApiRequestInit({ id: showId, limit: 0, trackId: id }));
      }
    }
  } catch (error) {
    if (!IS_TEST_ENVIRONMENT) {
      console.error('Player.sagas.handleTrackApiRequest()', error);
    }

    if (error instanceof Error) {
      yield put(A.trackApiRequestFailure({ error }));
    }

    const nextAvailableTrackIdInPlaylist: ReturnType<typeof SL.getNextAvailableTrackIdInPlaylist> =
      yield select(SL.getNextAvailableTrackIdInPlaylist);
    yield put(A.setCurrentlyPlayingTrackId({ id: nextAvailableTrackIdInPlaylist }));
    if (!nextAvailableTrackIdInPlaylist) {
      yield put(A.setPlayStatus({ playStatus: C.STOPED }));
    }
  }
};

/******************************************************************************
 *                              Log events API
 *****************************************************************************/
export const watchSendLogEvent = function* () {
  yield takeLatest(C.SEND_LOG_EVENT, handleSendLogEvent);
};

export const handleSendLogEvent = function* (action: ReturnType<typeof A.sendLogEvent>) {
  try {
    yield call(PlayerService.sendLogEvent, action.payload);
  } catch (error) {
    if (!IS_TEST_ENVIRONMENT) {
      console.error('Player.sagas.handleSendLogEvent()', error);
    }
  }
};

export default [watchShowApiRequest, watchTrackApiRequest, watchSendLogEvent];
